import loadable from '@loadable/component';
export const manifest = {
  FileLinkV2: {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "FileLinkV2";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "FileLinkV2" */
          './desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./desktop");
            }

            return eval('require.resolve')("./desktop");
          }

        }, {
          resolveComponent: mod => mod.FileLinkV2Desktop
        })
      },
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "FileLinkV2Mobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "FileLinkV2Mobile" */
          './mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./mobile");
            }

            return eval('require.resolve')("./mobile");
          }

        }, {
          resolveComponent: mod => mod.FileLinkV2Mobile
        })
      }
    }
  }
};